/* eslint-disable react-hooks/exhaustive-deps */
import { useLocation, useNavigate } from "react-router-dom";
import ReviewComponent from "../component/ReviewComponent";
import ReviewPageDropdown from "../component/ReviewPageDropdown";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import { useEffect, useRef, useState } from "react";
import {
  editRecordingSummary,
  getRecordingStatus,
  summaryView,
} from "../services/solevaniaService";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { useDiagnoszas } from "../hooks/useDiagnozas";
import { useSifreStoritve } from "../hooks/useSifreStoritive";

// const values = [
//   {
//     heading: 'Anamneza',
//     text: 'Patient reports chest pain for three days, worsened with activity. History of hypertension for five years and diabetes for three years. Currently taking Metformin and Amlodipine. Family history includes stroke and hypertension in the father and diabetes in the mother. Smokes ten cigarettes daily, follows a poor diet, and has a sedentary lifestyle.',
//   },
//   {
//     heading: 'Klinični status',
//     text: 'Blood pressure is 145/90 mmHg, heart rate 88 bpm, oxygen saturation 96%, temperature 37.2°C, and respiratory rate 18 breaths per minute. Physical examination reveals no abnormal lung or heart sounds, and no signs of edema.',
//   },
//   {
//     heading: 'Plan',
//     text: 'Prescribed Aspirin and Atorvastatin with a possible beta-blocker. Ordered ECG, cardiac enzymes, and a stress test within 48 hours. Recommended smoking cessation, dietary improvements, and 30 minutes of daily exercise. Follow-up in one week, with a cardiology referral if symptoms persist.',
//   },
// ];

export default function PatientReview({ setActiveStep }) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [summaryData, setSummaryData] = useState(null);
  const [anamnezaValue, setAnamnezaValue] = useState("");
  const [klinicniStatus, setKlinicniStatus] = useState("");
  const [Plan, setPlan] = useState("");
  const [sifraCodes, setSifraCodes] = useState([]);
  const [diagnozaCodes, setDiagnozaCodes] = useState([]);
  const [summaryId, setSummaryId] = useState(null);
  const [isRecordingStatus, setIsRecordingStatus] = useState(false);
  const { data: icdCodes } = useDiagnoszas();
  const { data: sifra_codes } = useSifreStoritve();
  const hasFetchedSummary = useRef(false);

  const handleSummaryView = async (id) => {
    const payload = {
      recording_id: id,
    };

    try {
      const response = await summaryView(payload);

      if (response?.data?.status) {
        setSummaryData(response?.data?.data);
      }
    } catch (error) {
      console.error("Error happened while submit recording", error);
    }
  };

  const handlegetRecordingStatus = async (recordingId) => {
    setIsRecordingStatus(true);
    try {
      const recordingResponse = await getRecordingStatus(recordingId);
      if (recordingResponse?.data?.status) {
        if (
          recordingResponse?.data?.data?.status === "processing" &&
          !summaryData
        ) {
          setTimeout(() => {
            handlegetRecordingStatus(recordingId);
          }, 5000);
        } else {
          setIsRecordingStatus(false);
          handleSummaryView(state?.recordingId);
        }
      }
      console.log("recordingResponse", recordingResponse);
      console.log();
    } catch (error) {
      console.error("Error:", error);
      toast.error(`An error occurred: ${error.message}`);
      setIsRecordingStatus(false);
    }
  };

  useEffect(() => {
    if (!state?.recordingId) return;
    if (hasFetchedSummary.current) return;

    setActiveStep(2);
    handlegetRecordingStatus(state?.recordingId);
    hasFetchedSummary.current = true;
  }, [state?.recordingId]);

  useEffect(() => {
    if (summaryData?.summaries) {
      setAnamnezaValue(summaryData?.summaries?.anamneza);
      setKlinicniStatus(summaryData?.summaries?.klinicni_status);
      setPlan(summaryData?.summaries?.plan);
      setSummaryId(summaryData?.summaries?.id);
      setSifraCodes(summaryData?.summaries?.sifra_codes);

      setDiagnozaCodes(() =>
        summaryData?.summaries?.icd_codes.map((i) => ({
          id: i.icd_code,
          code: i.icd_code,
          description: i.description,
        }))
      );
    }
  }, [summaryData]);

  const handleNext = async () => {
    const payload = {
      recording_id: state?.recordingId,
      summary_id: summaryId,
      anamneza: anamnezaValue,
      klinicni_status: klinicniStatus,
      plan: Plan,
      icd_codes: diagnozaCodes.map((i) => i.code),
      sifra_codes: sifraCodes.map((i) => ({ id: i.id })),
    };

    const response = await editRecordingSummary(payload);
    if (response?.data?.status) {
      // toast.success("Povzetek snemanja uspešno shranjen");
      navigate("/home/walkthrough/wrap-up", {
        state: { ...state },
      });
      setActiveStep(3);
    }
  };

  return (
    <>
      {isRecordingStatus && !summaryData && (
        <div className="fixed top-0 left-0 bg-black/5 h-full w-full z-50 backdrop-blur-sm">
          <div className="h-full flex flex-col items-center justify-center gap-2">
            <CircularProgress />
            <p className="animate-pulse">
              We are processing your recording. Please wait until it finishes.
            </p>
          </div>
        </div>
      )}

      <div className="flex flex-col p-3 gap-4">
        <ReviewComponent
          heading={"Medical History"}
          text={anamnezaValue}
          setValue={setAnamnezaValue}
        />

        <ReviewComponent
          heading={"Clinical Status"}
          text={klinicniStatus}
          setValue={setKlinicniStatus}
        />

        <ReviewPageDropdown
          text="Diagnosis"
          lists={icdCodes}
          setCodes={setDiagnozaCodes}
          codes={diagnozaCodes}
          placeHolder="Search ICD-10 code"
          isNested={true}
        />

        <ReviewComponent heading={"Plan"} text={Plan} setValue={setPlan} />

        <ReviewPageDropdown
          text="Service Codes"
          lists={sifra_codes}
          setCodes={setSifraCodes}
          codes={sifraCodes}
          placeHolder="Search service code"
        />

        <div className="flex justify-between w-full">
          <button
            onClick={() => navigate(-1)}
            className="p-3 bg-[#B4B4B4] text-[#015A52] rounded-full cursor-pointer"
          >
            <WestIcon />
          </button>
          <button
            onClick={handleNext}
            className="p-3 bg-[#B4B4B4] text-[#015A52] rounded-full cursor-pointer"
          >
            <EastIcon />
          </button>
        </div>
      </div>
    </>
  );
}
